import React from 'react';
import { makeStyles } from '@material-ui/core';
import loading from '../assets/loading.svg';

const useStyles = makeStyles(() => ({
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    flexGrow: 1
  }
}));

const Loading = () => {
  const classes = useStyles();
  return (
    <div className={classes.spinner}>
      <img src={loading} alt='loading' />
    </div>
  );
};

export default Loading;
